const INSERIR_LISTA_CAMPOS = (state, payload) => {
  state.items = payload
}

const BUSCANDO = (state, payload) => {
  state.buscando = payload
}

export {
  INSERIR_LISTA_CAMPOS,
  BUSCANDO
}